import { render, staticRenderFns } from "./CreateEmptyOne.vue?vue&type=template&id=4942329e&"
import script from "./CreateEmptyOne.vue?vue&type=script&lang=js&"
export * from "./CreateEmptyOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports